import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { motion, Variants } from 'framer-motion';

const useStyles = makeStyles((theme: Theme) => ({
    root: {
        position: 'absolute',
        top: 0,
        right: 0,
        bottom: 0,
        left: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    motionDiv: {
        position: 'relative',
        zIndex: 50,
        width: '100%',
        backgroundColor: theme.palette.common.black,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    }
}))


const blackBox: Variants = {
    initial: {
        height: "100vh",
        bottom: 0,
    },
    animate: {
        height: 0,
        // bottom: '100%',
        transition: {
            duration: 2.5,
            ease: [0.87, 0, 0.13, 1],
        },
    },
};

const InitialTransition = () => {
    const classes = useStyles()

    return (
        <div className={classes.root}>
            <motion.div
                className={classes.motionDiv}
                initial="initial"
                animate="animate"
                variants={blackBox}
            />
        </div>
    );
};

export default InitialTransition